/* eslint-disable */
export function formAddToMC(form) {

  $(form).on('submit', function(e){
    e.preventDefault();

	let validated 	= true;

	var formBtn 	= $(this).find('[type="submit"]'),
	formStatus  	= $(this).find('.status'),
	fieldEmail 		= $(this).find('#mce-EMAIL').val(),
  	fieldTrap  		= $(this).find('[name="b_d3549b4744ae019951bc135ba_ed525c59c8"]').val();

	//Indicate progress
	//
	formBtn.attr('value', 'Processing...').addClass('processing');

	//if Fields don't match throw error
	//
	if(fieldEmail == '') {
		formStatus.html('You must include an email address').addClass('error');
		formBtn.attr('value', 'Subscribe').removeClass('processing');
		validated = false;
  	}

	if(fieldTrap !== '') {
		formBtn.attr('value', 'Whoops').removeClass('processing');
		formStatus.html('Whoops, are you a robot??');
		validated = false;
    }

    if(validated == true) {

		//we made it, let's process this badboy
		//
		$.ajax({
    		type: 'POST',
    		dataType: 'json',
    		url: ajax_login_object.ajaxurl,
    		data: {
        		'action': 'addtomc',
        		'email': fieldEmail,
    		},

    		success: function(data){

				console.log(data);

        		formStatus.html(data.msg).removeClass('d-none text-secondary');

        		if (data.error){
            		formBtn.removeClass('processing').attr('value', 'Try again');
					$(form).on('change update', function(){
						formBtn.attr('value', 'Subscribe');
					});

					if(data.errors) {
						$.each(data.errors, function() {
							formStatus.append(' '.this.message);
						});
					}

        		} else {

					formBtn.removeClass('processing').attr('value', 'Success!');
        		}
    		}

		});

    }

  });

}

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/functions/mailchimp.js